<template>
    <div>
        <div v-for="(item, index) in list" :key="index" style="display: flex; align-items: center; margin-bottom: 5px;">
            <b-form-select
                v-model="item.selectedCategoryId"
                placeholder="请选择服务分类"
                :options="categoryList"
                @change="onCategoryChange(index)"
                text-field="name"
                value-field="category_id"
                style="margin-right: 5px; min-width: 150px;">
                <template #first>
                    <b-form-select-option :value="null" disabled>-- 选择服务分类 --</b-form-select-option>
                </template>
            </b-form-select>
            <b-form-select
                v-model="item.selectedGoodsId"
                placeholder="请选择服务项目"
                :options="item.filteredGoods"
                text-field="goods_name"
                value-field="goods_id"
                style="margin-right: 5px; min-width: 180px;">
                <template #first>
                    <b-form-select-option :value="null" disabled>-- 选择服务项目 --</b-form-select-option>
                </template>
            </b-form-select>
            <b-button size="sm" variant="success" @click="addRow" style="margin-right: 5px;">+ 添加</b-button>
            <b-button size="sm" variant="danger" @click="removeRow(index)" :disabled="list.length <= 1">删除</b-button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        // 传入 goods_id 数组，如 [1, 2]
        value: {
            type: Array,
            default: () => [null]
        },
        // 服务分类列表
        /*
        categoryList: {
            type: Array,
            default: () => [
                []
                //{ category_id: 14, code: '20221201161618872llnfsi', name: '开锁换锁' },
                //{ category_id: 15, code: '20221201161804932wkuohu', name: '防水补漏' }
            ]
        },
        // 服务项目列表
        goodsList: {
            type: Array,
            default: () => [
                []
                //{ goods_id: 1, goods_code: '', category_id: 14, goods_name: '房门开锁换锁' },
                //{ goods_id: 2, goods_code: '', category_id: 15, goods_name: '测试防水补漏' }
            ]
        }
        */
    },
    data() {
        return {
            list: [],
            categoryList: [],
            categoryList: []
        };
    },
    mounted() {
        this.initList();
        
    },
    methods: {
        // 根据传入的 value 初始化列表
        async initList() {
            let res = await this.getCategoryNew()
            this.categoryList = res.category;
            this.goodsList = res.goodsList;
            let ids = this.value && this.value.length > 0 ? this.value : [null];
            let newList = ids.map(goodsId => {
                let goods = this.goodsList.find(g => g.goods_id === goodsId);
                let categoryId = goods ? goods.category_id : null;
                return {
                    selectedCategoryId: categoryId,
                    selectedGoodsId: goodsId || null,
                    filteredGoods: this.getGoodsByCategory(categoryId)
                };
            });
            this.list = newList;
        },
        // 根据分类 ID 过滤商品
        getGoodsByCategory(categoryId) {
            if (!categoryId) return [];
            return this.goodsList.filter(g => g.category_id == categoryId);
        },
        // 分类变更时更新商品列表
        onCategoryChange(index) {
            let row = this.list[index];
            row.selectedGoodsId = null;
            row.filteredGoods = this.getGoodsByCategory(row.selectedCategoryId);
        },
        // 新增一行
        addRow() {
            this.list.push({
                selectedCategoryId: null,
                selectedGoodsId: null,
                filteredGoods: []
            });
        },
        // 删除一行
        removeRow(index) {
            this.list.splice(index, 1);
        },
        // 输出 goods_id 数组
        emitValue() {
            let result = this.list.map(row => row.selectedGoodsId);
            this.$emit('input', result);
        },
        getCategoryNew() {
            return new Promise((resolve, reject) => {
                this.category = [];
                this.post('goodsList_get', { category_id: 0 }).then((res) => {
                    console.log('获取分类列表servicePicker:', res)
                    resolve(res)
                })
            })
        },
    },
    watch: {
        list: {
            handler() {
                this.emitValue();
            },
            deep: true
        },
        value: {
            handler(newVal) {
                if (!newVal) return;
                let currentIds = this.list.map(row => row.selectedGoodsId);
                // 长度变化时重新初始化
                if (newVal.length !== currentIds.length) {
                    this.initList();
                    return;
                }
                // 逐位比较，不一致则重新初始化
                for (let i = 0; i < newVal.length; i++) {
                    if (newVal[i] !== currentIds[i]) {
                        this.initList();
                        return;
                    }
                }
            },
            deep: true
        }
    }
};
</script>
